import type { LucideIcon, LucideProps } from 'lucide-react'
import * as LucideIcons from 'lucide-react'

export type CMSIconLucideProps = LucideProps & {
  name: string
}

// lucide-react's namespace type doesn't structurally match Record<string, LucideIcon>
// (icon aliases, type-only exports) - Object.hasOwn is the real runtime guard here
function resolveLucideIcon(name: string): LucideIcon {
  if (!Object.hasOwn(LucideIcons, name)) {
    return LucideIcons.HelpCircle
  }

  return (LucideIcons as unknown as Record<string, LucideIcon>)[name] ?? LucideIcons.HelpCircle
}

export function CMSIconLucide({ name, ...props }: CMSIconLucideProps) {
  const IconComponent = resolveLucideIcon(name)

  return <IconComponent {...props} />
}
